import { getAuthToken } from "@Eikochain/auth";
import { Navigate, Outlet } from "react-router-dom";

export const PrivateRoutes = () => {
    const token = getAuthToken();
    return token === undefined ? <Navigate to="/auth/" /> : <Outlet />;
};
